import {Component, HostBinding, Input} from "@angular/core";

@Component({
    selector: "fui-three-columns",
    styleUrls: ["./three-columns.component.scss"],
    templateUrl: "./three-columns.component.html"
})
export class FUIThreeColumnsComponent {
    @Input() minColWidth: number = 250;
    @HostBinding("class.labelled") @Input() public label: string;
    @HostBinding("class.bordered") @Input() bordered: boolean;
    @Input() i18nParams: any = {};
}
